import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBatchPayment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2278 15.2267C14.2422 15.2267 15.0646 14.4044 15.0646 13.39C15.0646 12.3756 14.2422 11.5532 13.2278 11.5532C12.2134 11.5532 11.3911 12.3756 11.3911 13.39C11.3911 14.4044 12.2134 15.2267 13.2278 15.2267Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9421 7.88989H7.84009C6.48756 7.88989 5.39111 8.98634 5.39111 10.3389V16.4409C5.39111 17.7934 6.48756 18.8899 7.84009 18.8899H18.9421C20.2947 18.8899 21.3911 17.7934 21.3911 16.4409V10.3389C21.3911 8.98634 20.2947 7.88989 18.9421 7.88989Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.27876 16.4425H5.05787C3.70533 16.4425 2.60889 15.3461 2.60889 13.9935V10.2445V7.55909C2.60889 6.20655 3.70533 5.11011 5.05787 5.11011H11.3813H16.942C18.2945 5.11011 19.3909 6.20655 19.3909 7.55909V7.68565",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6013 11.5637C19.8365 11.434 19.131 11.0697 18.5825 10.5212C18.034 9.97275 17.6697 9.26722 17.54 8.50244",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.54 18.1851C17.6697 17.4203 18.034 16.7148 18.5825 16.1663C19.131 15.6178 19.8365 15.2535 20.6013 15.1239",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.26855 15.1239C7.03334 15.2535 7.73886 15.6178 8.28736 16.1663C8.83585 16.7148 9.20016 17.4203 9.32978 18.1851",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.32978 8.50244C9.20016 9.26722 8.83585 9.97275 8.28736 10.5212C7.73886 11.0697 7.03334 11.434 6.26855 11.5637",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgBatchPayment;
